/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
} from './Match';

/**
 * 
 * @export
 * @interface PaginatedMatchList
 */
export interface PaginatedMatchList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMatchList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMatchList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMatchList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Match>}
     * @memberof PaginatedMatchList
     */
    results?: Array<Match>;
}

/**
 * Check if a given object implements the PaginatedMatchList interface.
 */
export function instanceOfPaginatedMatchList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedMatchListFromJSON(json: any): PaginatedMatchList {
    return PaginatedMatchListFromJSONTyped(json, false);
}

export function PaginatedMatchListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMatchList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MatchFromJSON)),
    };
}

export function PaginatedMatchListToJSON(value?: PaginatedMatchList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MatchToJSON)),
    };
}

